<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    @closed="handleClosed"
    append-to-body>
    <!-- 筛选区 -->
    <el-form :inline="true" size="mini" class="spsd-filter">
      <el-form-item label="标签">
        <el-select v-model="selectedLabelIds" multiple collapse-tags filterable clearable placeholder="选择标签" style="width: 170px" @change="queryCustomers">
          <el-option-group v-for="g in labelGroups" :key="'g' + g.typeId" :label="g.typeName + '（' + g.labels.length + '）'">
            <el-option v-for="lb in g.labels" :key="lb.labelId" :label="lb.labelName" :value="lb.labelId">
              <span class="spsd-opt">
                <i class="spsd-opt-color" :style="{ background: lb.color || '#409EFF' }"></i>
                <span class="spsd-opt-name">{{ lb.labelName }}</span>
              </span>
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="组织机构">
        <ybl-organization :show-checkbox="true" v-model="selectedOrgIds" placeholder="请选择组织机构" style="width: 220px" />
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="keyword" placeholder="姓名/登录名/手机号" clearable style="width: 150px" @keyup.enter.native="queryCustomers" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCustomers">查询</el-button>
      </el-form-item>
    </el-form>
    <div v-loading="loading" style="min-height: 160px">
      <el-table ref="hitTable" :data="hitCustomers" size="mini" border max-height="280" @selection-change="handleSelectionChange" row-key="customerId" :reserve-selection="true">
        <el-table-column type="selection" width="42" />
        <el-table-column label="姓名" prop="realName" min-width="90" />
        <el-table-column label="工号" prop="personCode" min-width="120" />
        <el-table-column label="登录名" prop="loginName" min-width="90" />
        <el-table-column label="手机号" prop="mobile" min-width="110" />
        <el-table-column label="组织机构" min-width="140">
          <template slot-scope="scope">{{ scope.row.organizationName || scope.row.branchName || '' }}</template>
        </el-table-column>
        <el-table-column label="标签" min-width="160">
          <template slot-scope="scope">
            <span v-for="lb in (scope.row.labelList || [])" :key="lb.labelId" class="spsd-cell-tag">
              <i class="spsd-cell-dot" :style="{ background: lb.color || '#409EFF' }"></i>{{ lb.labelName }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!loading && hitCustomers.length === 0" class="spsd-empty">请选择标签/组织/关键字后查询，或当前条件下暂无人员</div>
    </div>
    <!-- 已选人员 -->
    <div v-if="pickedList.length" class="spsd-picked">
      <div class="spsd-picked-title">已选人员（{{ pickedList.length }}）：</div>
      <el-tag v-for="p in pickedList" :key="p.customerId" closable size="mini" class="spsd-picked-tag" @close="removePicked(p)">{{ p.realName || p.customerId }}（{{ p.customerId }}）</el-tag>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定（已选 {{ pickedList.length }} 人）</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SalesPersonSelectDialog',
  components: {},
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '按组织标签筛选人员' },
    labelOptions: { type: Array, default: () => [] },
    selectedIds: { type: Array, default: () => [] }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      innerLabelOptions: [],
      selectedLabelIds: [],
      selectedOrgIds: [],
      keyword: '',
      hitCustomers: [],
      pickedList: []
    }
  },
  computed: {
    labelGroups () {
      const map = {}
      const groups = []
      ;(this.innerLabelOptions || []).forEach(lb => {
        if (!map[lb.typeId]) {
          map[lb.typeId] = { typeId: lb.typeId, typeName: lb.typeName || '未分类', labels: [] }
          groups.push(map[lb.typeId])
        }
        map[lb.typeId].labels.push(lb)
      })
      return groups
    },
    partnerId () {
      const user = this.$store.getters.CUSTOMER_LOGINCUSTOMER
      return (user && user.data && user.data.PartnerId) || ''
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
      if (val) {
        this.loadLabels()
        this.initPicked()
        this.queryCustomers()
      }
    }
  },
  methods: {
    initPicked () {
      const ids = (this.selectedIds || []).map(String)
      this.pickedList = ids.map(cid => ({ customerId: cid }))
    },
    async loadLabels () {
      if (this.labelOptions && this.labelOptions.length) {
        this.innerLabelOptions = this.labelOptions
        return
      }
      try {
        const res = await this.$store.dispatch('salesLabelQueryAll', { partnerId: this.partnerId })
        this.innerLabelOptions = (res && res.data) || []
      } catch (e) {
        this.innerLabelOptions = []
      }
    },
    async queryCustomers () {
      this.loading = true
      try {
        // 已选标签 → 先按标签取 customerId 集合，再交后端按组织/关键字过滤
        let customerIdList = []
        if (this.selectedLabelIds && this.selectedLabelIds.length) {
          const res = await this.$store.dispatch('salesLabelSalesQueryCustomerIdsByLabel', { partnerId: this.partnerId, labelIdList: this.selectedLabelIds })
          customerIdList = (res && res.data) || []
        }
        const orgList = Array.isArray(this.selectedOrgIds) ? this.selectedOrgIds : (this.selectedOrgIds ? String(this.selectedOrgIds).split(',').filter(Boolean) : [])
        const info = await this.$store.dispatch('salesLabelCustomerInfos', {
          partnerId: this.partnerId,
          customerIdList,
          organizationIdList: orgList.map(Number),
          keyword: this.keyword || ''
        })
        let infos = (info && info.data) || []
        // 标签列：按 customerId 批量取标签（保留 labelId/color，与人员列表标签列一致）
        if (infos.length) {
          const lbl = await this.$store.dispatch('salesLabelCustomerLabels', {
            partnerId: this.partnerId,
            customerIdList: infos.map(i => Number(i.customerId))
          }).catch(() => null)
          const map = (lbl && lbl.data) || {}
          infos = infos.map(i => {
            const key = String(i.customerId)
            return Object.assign({}, i, { labelList: map[key] || [] })
          })
        }
        this.hitCustomers = infos
        this._suppressSelection = true
        await this.$nextTick()
        await this.$nextTick()
        this.restoreChecked()
        this._suppressSelection = false
      } catch (e) {
        this._suppressSelection = false
        this.hitCustomers = []
      } finally {
        this.loading = false
      }
    },
    restoreChecked () {
      const table = this.$refs.hitTable
      if (!table) return
      const pickedMap = new Map(this.pickedList.map(p => [String(p.customerId), p]))
      this.hitCustomers.forEach(row => {
        if (pickedMap.has(String(row.customerId))) {
          table.toggleRowSelection(row, true)
        }
      })
    },
    handleSelectionChange (rows) {
      // 数据刷新（查询/清筛选）期间的选择过渡事件忽略，避免误清已选
      if (this._suppressSelection) return
      rows = rows || []
      const inTable = new Set(this.hitCustomers.map(r => String(r.customerId)))
      const selected = new Set(rows.map(r => String(r.customerId)))
      // 移除「在当前表格中已取消勾选」的项；保留「不在当前表格」的已选项（如清标签筛选后原人员仍在已选区）
      this.pickedList = this.pickedList.filter(p => !inTable.has(String(p.customerId)) || selected.has(String(p.customerId)))
      rows.forEach(r => {
        if (!this.pickedList.some(p => String(p.customerId) === String(r.customerId))) {
          this.pickedList.push({ customerId: r.customerId, realName: r.realName })
        }
      })
    },
    removePicked (p) {
      this.pickedList = this.pickedList.filter(x => String(x.customerId) !== String(p.customerId))
      const table = this.$refs.hitTable
      if (table) {
        const row = this.hitCustomers.find(r => String(r.customerId) === String(p.customerId))
        if (row) table.toggleRowSelection(row, false)
      }
    },
    handleConfirm () {
      this.$emit('confirm', this.pickedList.map(p => Number(p.customerId)))
      this.dialogVisible = false
    },
    handleClosed () {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.spsd-filter { margin-bottom: 4px; }
.spsd-empty { text-align: center; color: #909399; padding: 30px 0; font-size: 13px; }
.spsd-picked { margin-top: 8px; padding: 6px 8px; background: #f5f7fa; border-radius: 4px; }
.spsd-picked-title { font-size: 12px; color: #606266; margin-bottom: 6px; }
.spsd-picked-tag { margin-right: 6px; margin-bottom: 4px; }
.spsd-cell-tag { margin-right: 4px; }
.spsd-opt { display: inline-flex; align-items: center; width: 100%; }
.spsd-opt-color {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 6px;
  flex-shrink: 0;
}
.spsd-opt-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.spsd-opt-type { color: #8492a6; font-size: 12px; margin-left: 8px; }
.spsd-cell-tag {
  display: inline-flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 3px;
  padding: 1px 6px;
  margin-right: 4px;
  font-size: 12px;
  color: #303133;
}
.spsd-cell-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/SalesPersonSelectDialog.vue